import React, { useEffect, useState } from "react";
import { Container, Row, Col, Table, Spinner, Form } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import { FaTrash, FaEdit, FaEye } from "react-icons/fa";
import { getAllUsers, updateUserProfile } from "../../../../redux/authSlice";
import EditUserModal from './EditUserModal';
import { useNavigate } from "react-router-dom";

const Users = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { users, loading, error } = useSelector((state) => state.auth);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleEdit = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleSave = (updatedUser) => {
    setUserList(userList.map(user => user._id === updatedUser._id ? updatedUser : user));
    dispatch(updateUserProfile(updatedUser));
    setShowModal(false);
  };
  const handleDeactivate = (userId) => {
    const updatedUsers = userList.map(user =>
      user._id === userId ? { ...user, isActive: false } : user
    );
    setUserList(updatedUsers);
    // Optionally, dispatch an action to update the user in the backend
  };


  const filteredUsers = userList.filter((user) => {
    const term = debouncedSearchTerm.toLowerCase();
    return (
      user.name?.toLowerCase().includes(term) ||
      user.email?.toLowerCase().includes(term) ||
      user.whatsappNumber?.toLowerCase().includes(term)
    );
  });
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      localStorage.clear();
      navigate("/login");
    }
    if (users) {
      setUserList(users);
    }
  }, [users]);
  useEffect(() => {
    dispatch(getAllUsers()).then((response) => {
      setUserList(response.payload);
    });
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300); // delay in ms

    return () => clearTimeout(timer); // cleanup on re-render
  }, [searchTerm]);

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <div className="table-filter">
              <div className="table-filter__left">

                <Row className="dashboard__header">
                  <Col lg={8} md={6} sm={6} xs={12}>
                    <h2>Users List</h2>
                  </Col>
                  <Col lg={4} md={6} sm={6} xs={12}>
                    <Form.Group controlId="search" className="d-flex align-items-center justify-content-end">
                      <Form.Label className="me-2 fw-bold">Search</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Search by name, email or WhatsApp number"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </Form.Group>

                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <Table responsive>
              <thead>
                <tr>
                  <th className="text-nowrap">S.N</th>
                  <th className="text-nowrap">User ID</th>
                  <th className="text-nowrap">User Name</th>
                  <th className="text-nowrap">Photo</th>
                  <th className="text-nowrap">Whatsapp Number</th>
                  <th className="text-nowrap">Email</th>
                  <th className="text-nowrap">Role</th>
                  <th className="text-nowrap">Verify</th>
                  <th className="text-nowrap">Address</th>
                  <th className="text-nowrap">Created Date</th>
                  <th className="text-nowrap">Updated Date</th>
                  <th className="text-nowrap">Action</th>
                </tr>
              </thead>
              <tbody>
                {loading &&
                  <tr>
                    <td colSpan="12" className="text-center">
                      <Spinner animation="border" />
                      <p className="sr-only">Loading...</p>
                    </td>
                  </tr>
                }
                {!loading && userList.length === 0 &&
                  <tr>
                    <td colSpan="12" className="text-center">
                      <p>No data found</p>
                    </td>
                  </tr>
                }
                {!loading && filteredUsers.length === 0 && (
                  <tr>
                    <td colSpan="12" className="text-center">No users matched your search.</td>
                  </tr>
                )}
                {error && <tr><td colSpan="12" className="text-center">{error}</td></tr>}
                {filteredUsers && filteredUsers.map((user, index) => (
                  <tr key={user._id}>
                    <td>{index + 1}</td>
                    <td>{user._id}</td>
                    <td>{user.name}</td>
                    <td>
                      {user.profilePicture ? (
                        <img src={user.profilePicture} alt="Profile" style={{ width: "40px", height: "40px", borderRadius: "50%" }} />
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>{user.whatsappNumber}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>{user.isVerified ? "Verified" : "Not Verified"}</td>
                    <td>{user.address}</td>
                    <td>{new Date(user.createdAt).toLocaleString()}</td>
                    <td>{new Date(user.updatedAt).toLocaleString()}</td>
                    <td>
                      <button className="btn btn-primary btn-sm me-2" onClick={() => handleEdit(user)}>Edit</button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeactivate(user._id)}>Deactivate</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <EditUserModal
              show={showModal}
              handleClose={() => setShowModal(false)}
              userData={selectedUser || {}}
              handleSave={handleSave}
            />
          </Col>
        </Row>
      </Container >
    </>
  )
}

export default Users
